export default "__VITE_ASSET__DbkBaapc__"